import Swiper from 'swiper';

import Section from '../Section';

export default class ProductRecommendations extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.productId = this.element.dataset.productId;
    this.limit = this.element.dataset.limit;
    this.baseUrl = this.element.dataset.recommendationsUrl;
    this.sectionId = this.element.dataset.wethemeSectionId;
    this.load();
  }

  load = () => {
    // Build request URL
    const requestUrl = `${this.baseUrl}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}`;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        Array.prototype.forEach.call(
          container.children,
          (child) => {
            this.element.appendChild(child);
            Array.prototype.forEach.call(
              child.querySelectorAll('.shop-now-button'),
              (shopNow) => {
                if (shopNow) {
                  shopNow.addEventListener('click', this.handleShopNow);
                }
              },
            );
          },
        );
        this.theme.loadReviews({ badges: true });
        this.theme.addBadges(this.element, 1000);
      }

      const nextEl = this.element.querySelector('.swiper-button--next');
      const prevEl = this.element.querySelector('.swiper-button--prev');
      this.swiper = new Swiper(this.element.querySelector('.swiper-container'), {
        slidesPerView: 2,
        navigation: {
          nextEl,
          prevEl,
        },
        breakpoints: {
          600: {
            slidesPerView: 4,
          },
        },
        watchOverflow: true,
      });
    };
    request.send();
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.target.href });
  }
}
